<template>
  <mi-td>
    <div class="flex">
      <man-tag
        v-if="!ambiguousStatus || status === availableStatus.AMBIGUOUS_READY.key"
        class="q-mr-xs"
        size="l"
        :variant="availableStatus[status]?.color"
      >
        {{ availableStatus[status]?.title ?? 'unknown' }}
      </man-tag>

      <man-tag
        v-else
        class="q-mr-xs"
        size="l"
        :variant="ambiguousColorStatus?.color"
      >
        {{
          ambiguousMessageStatus()
        }}
      </man-tag>
    </div>
  </mi-td>
</template>

<script>
  import { computed, ref } from 'vue'
  import { AMBIGUOUS_RESULT_STATUS, RESULT_STATUS } from '@/constants'

  export default {
    name: 'SavedTablesListStatusColumn',
    props: {
      status: {
        type: String,
        required: false,
        default: ''
      },
      ambiguousStatus: {
        type: Object,
        required: false,
        default: null
      }
    },
    setup(props) {
      const availableStatus = ref(RESULT_STATUS)
      const ambiguousJobStatus = ref(AMBIGUOUS_RESULT_STATUS)

      const ambiguousColorStatus = computed(() => {
        const total = Number(props.ambiguousStatus?.total ?? 0)
        const complete = Number(props.ambiguousStatus?.complete ?? 0)
        const failed = Number(props.ambiguousStatus?.failed ?? 0)

        if (complete === total) {
          return ambiguousJobStatus.value.AMBIGUOUS_READY
        }

        if (failed > 0) {
          return ambiguousJobStatus.value.AMBIGUOUS_FAILED
        }

        if (complete === 0) {
          return ambiguousJobStatus.value.FIRST_CHECKING
        }

        if (total > 1 && complete < total) {
          return ambiguousJobStatus.value.AMBIGUOUS_CHECKING
        }

        return ambiguousJobStatus.value.FIRST_CHECKING
      })

      const ambiguousMessageStatus = () => {
        const totalAmbiguous = Number(props.ambiguousStatus?.total ?? 0)
        if (ambiguousColorStatus.value?.key === ambiguousJobStatus.value.AMBIGUOUS_FAILED.key) {
          return totalAmbiguous > 1 ? `${ props.ambiguousStatus?.failed } / ${ props.ambiguousStatus?.total } failed`
            : 'Ambiguous failed'
        }
        if (totalAmbiguous === 1) {
          return 'Ambiguous checking'
        }

        return `${ props.ambiguousStatus?.complete } / ${ props.ambiguousStatus?.total } ready`
      }

      return {
        availableStatus,
        ambiguousJobStatus,
        ambiguousColorStatus,
        ambiguousMessageStatus
      }
    }
  }
</script>

<style lang="scss">
  .status-column {
    &__badge {
      &--in-progress {
        background-color: $mi-blue-800;
      }

      &--success {
        background-color: $mi-green-700;
      }

      &--failed {
        background-color: $mi-red-800;
      }
    }
  }
</style>
